import type { Project } from '../projects.type'

/**
 * Resolves workspace-scoped project list and currentProject after fetching all user projects.
 * Keeps an optimistic currentProject when the API list has not caught up yet.
 */
export function resolveProjectsStateAfterWorkspaceFetch(
  allProjects: Project[],
  targetWorkspaceId: string,
  currentProject: Project | null
): { projects: Project[]; currentProject: Project | null } {
  const filtered = allProjects.filter((project) => project.workspaceId === targetWorkspaceId)
  const currentBelongsToWorkspace = currentProject?.workspaceId === targetWorkspaceId

  if (currentBelongsToWorkspace && currentProject) {
    const fromList = filtered.find((project) => project.projectId === currentProject.projectId)

    if (fromList) {
      return { projects: filtered, currentProject: fromList }
    }

    return { projects: [...filtered, currentProject], currentProject }
  }

  const shouldKeepCurrentProject = filtered.some((project) => project.projectId === currentProject?.projectId)

  return {
    projects: filtered,
    currentProject: shouldKeepCurrentProject ? currentProject : null,
  }
}
